var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.param)?_c('a',{staticClass:"btn",attrs:{"href":'/SAPCXDAY/register/profile/?code=' + this.param}},[_vm._v("参加登録")]):_c('a',{staticClass:"btn",attrs:{"href":"/SAPCXDAY/register/profile/"}},[_vm._v("参加登録")])}
var staticRenderFns = []

export { render, staticRenderFns }